"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.buildTransaction = void 0;
var wallet_btc_1 = require("./wallet-btc");
var errors_1 = require("@ledgerhq/errors");
var types_1 = require("./types");
var wallet_btc_2 = __importStar(require("./wallet-btc"));
var logs_1 = require("@ledgerhq/logs");
var selectUtxoPickingStrategy = function (walletAccount, utxoStrategy) {
    var _a;
    var handler = (_a = {},
        _a[types_1.bitcoinPickingStrategy.MERGE_OUTPUTS] = wallet_btc_1.Merge,
        _a[types_1.bitcoinPickingStrategy.DEEP_OUTPUTS_FIRST] = wallet_btc_1.DeepFirst,
        _a[types_1.bitcoinPickingStrategy.OPTIMIZE_SIZE] = wallet_btc_1.CoinSelect,
        _a)[utxoStrategy.strategy];
    if (!handler)
        throw new Error("Unsupported Bitcoin UTXO picking strategy");
    return new handler(walletAccount.xpub.crypto, walletAccount.xpub.derivationMode, utxoStrategy.excludeUTXOs);
};
var buildTransaction = function (account, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var walletAccount, utxoPickingStrategy, maxSpendable, txInfo;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!transaction.feePerByte) {
                    throw new errors_1.FeeNotLoaded();
                }
                walletAccount = (0, wallet_btc_2.getWalletAccount)(account);
                utxoPickingStrategy = selectUtxoPickingStrategy(walletAccount, transaction.utxoStrategy);
                return [4 /*yield*/, wallet_btc_2["default"].estimateAccountMaxSpendable(walletAccount, transaction.feePerByte.toNumber(), //!\ wallet-btc handles fees as JS number
                    transaction.utxoStrategy.excludeUTXOs, transaction.utxoStrategy.pickUnconfirmedRBF, [transaction.recipient])];
            case 1:
                maxSpendable = _a.sent();
                (0, logs_1.log)("btcwallet", "building transaction", transaction);
                return [4 /*yield*/, wallet_btc_2["default"].buildAccountTx({
                        fromAccount: walletAccount,
                        dest: transaction.recipient,
                        amount: transaction.useAllAmount ? maxSpendable : transaction.amount,
                        feePerByte: transaction.feePerByte.toNumber(),
                        utxoPickingStrategy: utxoPickingStrategy,
                        // Definition of replaceable, per the standard: https://github.com/bitcoin/bips/blob/61ccc84930051e5b4a99926510d0db4a8475a4e6/bip-0125.mediawiki#summary
                        sequence: transaction.rbf ? 0 : 0xffffffff
                    })];
            case 2:
                txInfo = _a.sent();
                (0, logs_1.log)("btcwallet", "txInfo", txInfo);
                return [2 /*return*/, txInfo];
        }
    });
}); };
exports.buildTransaction = buildTransaction;
//# sourceMappingURL=js-buildTransaction.js.map